// src/fonts/registerFonts.js
import { Font } from "@react-pdf/renderer";
import MontserratRegular from "../assets/fonts/Montserrat-Regular.ttf";
import MontserratBold from "../assets/fonts/Montserrat-Bold.ttf";
import MontserratMedium from "../assets/fonts/Montserrat-Medium.ttf";
import MontserratSemiBold from "../assets/fonts/Montserrat-SemiBold.ttf";

Font.register({
  family: "Montserrat",
  fonts: [
    { src: MontserratRegular, fontWeight: "normal" },
    { src: MontserratBold, fontWeight: "bold" },
    { src: MontserratMedium, fontWeight: "medium" },
    { src: MontserratSemiBold, fontWeight: "semibold" },
  ],
});
